<template>
  <div class="servicos-page">
    <Box :title="t('Serviços')" icon="pi pi-briefcase">
      <template #actions>
        <Button
          data-testid="servicos-btn-novo"
          :label="t('Novo')"
          icon="pi pi-plus"
          @click="handleNewServico"
        />
      </template>

      <servicos-table
        ref="tableRef"
        data-testid="servicos-table"
        @edit="handleEditServico">
      </servicos-table>
    </Box>

    <!-- ServicosModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import Box from '../../ui/Box.vue';
import ServicosTable from './ServicosTable.vue';
// ServicosModal is centralized in ModalManager.vue

const { t } = useI18n();

const tableRef = ref<InstanceType<typeof ServicosTable> | null>(null);

const handleNewServico = (): void => {
  log('ServicosPage', 'handleNewServico', 'Emitting modal open event for new servico');
  eventBus.emit('modal.servicos.open', { id: null });
};

const handleEditServico = (servicoId: number | string): void => {
  log('ServicosPage', 'handleEditServico', 'Emitting modal open event for edit', servicoId);
  eventBus.emit('modal.servicos.open', { id: servicoId });
};

onMounted(() => {
  log('ServicosPage', 'mounted', 'Component mounted');
});
</script>

<style scoped>
.servicos-page {
  padding: 0;
}
</style>
